module.exports = __webpack_public_path__ + "img/pdf.f02f4b4c.svg";